import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useMenuStore = defineStore('menu', () => {
  const isOpen = ref(true)
  const wasClosedByCreator = ref(false)

  function toggleOpen() {
    isOpen.value = !isOpen.value
    wasClosedByCreator.value = false
  }

  function closeMenuAutomaticallyIfOpened() {
    if (isOpen.value === true) {
      isOpen.value = false
      wasClosedByCreator.value = true
    }
  }

  function expandMenuIwWasAutomaticallyHidden() {
    if (wasClosedByCreator.value === true && isOpen.value === false) {
      isOpen.value = true
      wasClosedByCreator.value = false
    }
  }

  return { isOpen, closeMenuAutomaticallyIfOpened, expandMenuIwWasAutomaticallyHidden, toggleOpen }
})
